import { IBidResponse, IAuctionResults } from '../../typings/IPrebid'
import { IBidRequest } from '../../typings/IPrebidAdapter'
import { PubSub } from '../helpers/pubSub'
import { Slot } from '../slots/Slot'

export enum Event {
  impressionViewable = 'impressionViewable',
  slotVisibilityChanged = 'slotVisibilityChanged',
  slotRenderEnded = 'slotRenderEnded',
  slotWrapperRenderEnded = 'slotWrapperRenderEnded',
  bidResponse = 'bidResponse',
  bidWon = 'bidWon',
  auctionEnd = 'auctionEnd',
  bidRequested = 'bidRequested',
  bidReady = 'bidReady', // Custom Event
  bidTimeout = 'bidTimeout',
  newRelicLoaded = 'newRelicLoaded',
  timeOnSite = 'timeOnSite'
}

/**
 * Singleton Export
 * Testing is done in pubSub class which holds all the logic
 * This class just acts as a proxy for defining the interface
 */

class EventManager extends PubSub<typeof Event> {
  events = Event

  on(
    event: Event.bidReady,
    cb: (auctionResultsSet: Array<IAuctionResults>) => void
  ): EventManager
  on(
    event: Event.bidResponse | Event.bidWon,
    cb: (bidResponse: IBidResponse) => void
  ): EventManager
  on(
    event: Event.bidRequested,
    cb: (bidRequest: IBidRequest) => void
  ): EventManager
  on(
    event: Event.bidTimeout,
    cb: (bidRequests: Array<IBidRequest>) => void
  ): EventManager
  on(event: Event.auctionEnd, cb: (eventObj) => void): EventManager
  on(
    event: Event.slotRenderEnded,
    cb: (event: googletag.events.SlotRenderEndedEvent, slot?: Slot) => void
  ): EventManager
  on(
    event: Event.slotVisibilityChanged,
    cb: (
      event: googletag.events.slotVisibilityChangedEvent,
      slot?: Slot
    ) => void
  ): EventManager
  on(
    event: Event.impressionViewable,
    cb: (event: googletag.events.ImpressionViewableEvent, slot?: Slot) => void
  ): EventManager
  on(
    event: Event.slotWrapperRenderEnded,
    cb: (slot: Slot) => void
  ): EventManager
  on(event: Event, cb): EventManager {
    return super.on(event, cb)
  }

  trigger(
    event: Event.bidReady,
    eventObject: Array<IAuctionResults>
  ): EventManager
  trigger(
    event: Event.bidResponse | Event.bidWon,
    eventObject: IBidResponse
  ): EventManager
  trigger(event: Event.bidRequested, eventObject: IBidRequest): EventManager
  trigger(
    event: Event.bidTimeout,
    eventObject: Array<IBidRequest>
  ): EventManager
  trigger(event: Event.auctionEnd, eventObject): EventManager
  trigger(
    event: Event.slotRenderEnded,
    eventObject: googletag.events.SlotRenderEndedEvent,
    slot?: Slot
  ): EventManager
  trigger(
    event: Event.slotVisibilityChanged,
    eventObject: googletag.events.slotVisibilityChangedEvent,
    slot?: Slot
  ): EventManager
  trigger(
    event: Event.impressionViewable,
    eventObject: googletag.events.ImpressionViewableEvent,
    slot?: Slot
  ): EventManager
  trigger(event: Event.slotWrapperRenderEnded, slot: Slot): EventManager
  trigger(event: Event, ...args): EventManager {
    return super.trigger(event, ...args)
  }
}

export default new EventManager()
